import { useEffect, useState } from 'react';
import { Stomp } from '@stomp/stompjs';
import sockService from '../services/socket';


export default function useSocket(baseUrl) {
    const [client, setClient] = useState(null);
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        if (!baseUrl) return; 

        const socket = sockService.getSock(baseUrl); 
        const client = Stomp.over(socket);
        client.debug = (str) => { console.log('[STOMP]', str); }; 

        client.connect({}, () => {
            setClient(client);
            setSocket(socket);
        });

        return () => {
            if (socket) socket.close();
            if (client) client.disconnect();
        };
    }, [baseUrl]);


return { client, socket };
}